import { Pipe, PipeTransform } from '@angular/core';
import {
  PAYMENT_TYPE,
  PaymentType,
  PaymentTypeMeta,
} from '@lockton-apps/shared/interfaces';

export const PAYMENT_TYPE_META: Partial<Record<PaymentType, PaymentTypeMeta>> =
  {
    [PAYMENT_TYPE.Offline]: {
      icon: { name: 'card_phone_thin', color: 'green' },
      value: PAYMENT_TYPE.Offline,
      description: $localize`Card Payment by Phone`,
    },
    [PAYMENT_TYPE.Stripe]: {
      icon: { name: 'card_thin', color: 'pink' },
      value: PAYMENT_TYPE.Stripe,
      description: $localize`Credit or debit card`,
    },
    [PAYMENT_TYPE.PremiumFinance]: {
      icon: { name: 'monthly_payment_thin', color: 'orange' },
      value: PAYMENT_TYPE.PremiumFinance,
      description: $localize`Premium Finance`,
    },
    [PAYMENT_TYPE.Invoice]: {
      icon: { name: 'invoice_universal_thin', color: 'blue' },
      value: PAYMENT_TYPE.Invoice,
      description: $localize`Invoice (BACS or Cheque)`,
    },
  };

@Pipe({
  name: 'paymentTypeMeta',
  standalone: true,
})
export class PaymentTypeMetaPipe implements PipeTransform {
  transform(type: PaymentType): PaymentTypeMeta {
    return PAYMENT_TYPE_META[type] as PaymentTypeMeta;
  }
}
